import Component from "../../lib/Component.js";

const HeaderLoginToggle = (element, options = {}) => {
  const el = element;
  const opts = {
    ...options,
  };

  const icon = el ? el.querySelector("i.login-icon-off") : null;
  const originalIconClass = icon?.className;
  const loadingIconClass = "nav-item-icon login-icon-off fas fa-circle-notch fa-spin";

  const handleLoginToggleClick = (event) => {
    if (!component.isDisabled()) {
      if (opts.onLoginToggleClick) opts.onLoginToggleClick(event);
    }
  };

  const component = el
    ? new Component({
        componentName: "HeaderLoginToggle",
        onMount: () => {
          el.addEventListener("click", handleLoginToggleClick, false);
        },
        onUnmount: () => {
          el.removeEventListener("click", handleLoginToggleClick, false);
        },
      })
    : Component.noop();

  component.el = el;

  component.setLoading = (loading) => {
    if (el) {
      if (loading) {
        el.disabled = true;
        icon.className = loadingIconClass;
      } else {
        el.disabled = false;
        icon.className = originalIconClass;
      }
    }
  };

  component.isDisabled = () => {
    if (el) {
      return el.disabled;
    }
    return false;
  };

  return component;
};

export default HeaderLoginToggle;
